export default function RevenueStats({ amount = 0 }) {
  const value = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(Number(amount) || 0);
  return <article className="admin-metric admin-metric--revenue"><span>Recorded paid revenue</span><strong>{value}</strong><small>Based only on orders marked paid.</small></article>;
}
